var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-aside',{attrs:{"width":"216px"}},[_c('SideBarCmp',{attrs:{"isToggle":_vm.isToggleSideBar,"data":_vm.data}})],1),_c('el-container',[_c('el-header',{staticStyle:{"height":"85px"}},[_c('HeaderCmp',{on:{"toggleSideBar":_vm.toggleSideBar}})],1),_c('el-main',{staticClass:"elMain"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }